// ABOUTME: Assisted-selling company-specific UI override definition.
// ABOUTME: Registers the Assisted Selling page route and menu item.

import { AutoAwesomeOutlinedIcon } from '@ds/coolshop';
import { lazy } from 'react';

import { CompanyOverride } from './types';

const AssistedSellingPage = lazy(() => import('@pages/AssistedSellingPage'));

export const assistedSellingOverride: CompanyOverride = {
    companyIds: ['assisted-selling'],
    menuItems: [
        {
            id: 'assisted-selling',
            path: 'assisted-selling',
            icon: <AutoAwesomeOutlinedIcon />,
            isActive: () => true,
            order: 0,
        },
    ],
    routes: [
        {
            path: 'assisted-selling',
            component: AssistedSellingPage,
            isActive: () => true,
        },
    ],
    getDefaultRoute: () => '/assisted-selling',
};
